import {
    findPath,
    getFlatTree,
} from 'routes/HumanResourcesModule/PayState/helpers/treeHelpers';
import {
    OrgChartHrMapping,
    TreeDataForMappingGrid,
} from 'routes/HumanResourcesModule/Settings/OrgChartHrMappings/helpers/type';

/**
 * Converts a tree of organizational chart data into a flat array of objects
 * with a path key representing the ancestor of given object.
 * This path allows us to display the tree in AgGrod
 *
 * @param tree - The organizational chart data in tree format.
 * @param mappings - An array of mappings from org chart HR software IDs to other values.
 * @returns An array of objects with path, value, label, and mapping properties.
 */
export function convertOrgChartToFlatArray(
    tree: TreeT,
    mappings: OrgChartHrMapping[],
): TreeDataForMappingGrid[] {
    const flatTree = getFlatTree(tree);
    return flatTree
        .map((node) => {
            const deepCopiedNode = structuredClone(node);
            const path = findPath(tree, deepCopiedNode.value).filter(
                (p) => p !== 'ROOT',
            );
            const mapping =
                mappings.find((m) =>
                    m.orgChartHrs
                        .map((och) => och.softwareId)
                        .includes(deepCopiedNode.value),
                ) || null;
            return {
                path,
                value: deepCopiedNode.value,
                label: deepCopiedNode.label,
                mapping,
            };
        })
        .filter((deepCopiedNode) => deepCopiedNode.path.length > 0);
}
